
export const NodeMap = {
    heco: "https://http-mainnet-node.huobichain.com",
    bsc: "https://bsc-dataseed3.defibit.io",
    eth: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
    polygon: "https://polygon-rpc.com",
    ftm: 'https://rpc.ftm.tools',
    hsc: 'https://http-mainnet.hoosmartchain.com',
    bsctest: 'https://data-seed-prebsc-1-s1.binance.org:8545'
};

export const NativeSymbolMap = {
    bsctest: 'tBNB',
    heco: 'HT',
    bsc: 'BNB',
    eth: 'ETH',
    polygon: 'MATIC',
    ftm: 'FTM',
    hsc: 'HOO'
}

export const MulticallContractMap = {
    'bsctest': '0x3DCDb973fC7511325a5311381aA611C51595294D',
    'eth': '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
    "heco": '0x91258C01987e4364923DB22bf8D1f5fe16d0Ef67',
    "bsc": '0xc5d9B4142DE66A88b0655aCB56393Dcf24d0Abc1',
    "polygon": '0xcac0c6f4d091f38550bde307dce52187b370a85e',
    "ftm": '0x517B6d39C85811d62299b9eEF6CF3618507e03C8',
    "hsc": '0x88E84a79b4302145480BC9FD6fAF2709c18FDb23'
}

export const ContractMap = {
    'bsctest': '0x9d6AA2C72E9010e3519F1931823e36B71a59a855',
    "heco": '0xBa57D610785502B766eAB1a802F367958f823860',
    "bsc": '0xBa57D610785502B766eAB1a802F367958f823860',
    "eth": '0xfb0ed80d4bd2553c2b03a51226808e8170355053',
    "polygon": '0xBa57D610785502B766eAB1a802F367958f823860',
    "ftm": '0xBa57D610785502B766eAB1a802F367958f823860',
    "hsc": '0xBa57D610785502B766eAB1a802F367958f823860'
}


export const ChainIdMap = {
    heco: 128,
    bsc: 56,
    eth: 1,
    polygon: 137,
    ftm: 250,
    hsc: 70,
    bsctest: 97
};

export const IdChainMap = {
    128: 'heco',
    56: 'bsc',
    137: 'polygon',
    1: 'eth',
    250: 'ftm',
    97: 'bsctest',
    70: 'hsc'
}


export const DesignList = [
    {
        "twitter": "https://twitter.com/zrb19951025",
        "title": "ガアラ（我爱罗）",
        "descZh": "我爱罗，日本漫画《火影忍者》及其衍生作品中的角色。风之国·砂隐村的第五代风影。. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Garra is a shinobi of Sunagakure. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#965454",
        "layout": "full",
        "group": 1,
        "nfts": [
            {
                "id": 1,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/1.jpg"
            },
            {
                "id": 3,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/3.jpg"
            },
            {
                "id": 2,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/2.jpg"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x739a5b0844ca1f1bc50926d0e0bb4eb3b8aee7f5/eth"
    },
    {
        "twitter": "https://twitter.com/AlberttZHANG",
        "title": "lucky monster",
        "descZh": "幸运怪兽带你拯救世界. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Lucky monsters take you to save the world. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#FAE9FA",
        "layout": "full-three",
        "group": 2,
        "nfts": [
            {
                "id": 4,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/4.png"
            },
            {
                "id": 5,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/5.png"
            },
            {
                "id": 6,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/6.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x91553e5d066b322704fb70435a2fffbc43eb01e8/bsc"
    },
    {
        "twitter": "https://twitter.com/kodokcrypto",
        "title": "Beauty Rainbow",
        "descZh": "Beauty rainbow with special Token Poket skin will make your days happines. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Beauty rainbow with special Token Poket skin will make your days happines. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#000000",
        "layout": "single-width",
        "group": 3,
        "nfts": [
            {
                "id": 7,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/7.jpg"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x791678EF5a90eada12fEAB06aB2D2d6d88687aa2/bsc"
    },
    {
        "twitter": "https://twitter.com/sambara_wardana",
        "title": "Bromo: Spirit of Universe",
        "descZh": "This photo is original, it was taken by myself and edited with some efffect from #Lumii. This one about ritual purposes in Bromo (Java) somekind like Fuji Mountain in Japan. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "This photo is original, it was taken by myself and edited with some efffect from #Lumii. This one about ritual purposes in Bromo (Java) somekind like Fuji Mountain in Japan. . TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#01238F",
        "layout": "left",
        "group": 4,
        "nfts": [
            {
                "id": 9,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/9.jpg"
            },
            {
                "id": 8,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/8.jpg"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xa983ea847ab99df06b1e517e50a16d2648d08c2f"
    },
    {
        "twitter": "https://twitter.com/ImKakashi106",
        "title": "The Copy Ninja : Kakashi Hatake",
        "descZh": "Kakashi Hatake is a fictional character in the Naruto manga and anime series created by Masashi Kishimoto. In the story,    Kakashi is the teacher of Team 7,        consisting of the series' primary characters,       Naruto Uzumaki,       Sasuke Uchiha,     and Sakura Haruno. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。.",
        "descEn": "Kakashi Hatake is a fictional character in the Naruto manga and anime series created by Masashi Kishimoto. In the story,         Kakashi is the teacher of Team 7,      consisting of the series' primary characters,      Naruto Uzumaki,       Sasuke Uchiha,      and Sakura Haruno. TokenPocket’s First Wallet Skin NFT Design Competition works. .",
        "viewAll": true,
        "bgColor": "#2A0054",
        "layout": "left",
        "group": 5,
        "nfts": [
            {
                "id": 11,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/11.png"
            },
            {
                "id": 10,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/10.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x09ba028e22ca234db35441a8c3e7ad9a8175e021/bsc"
    },
    {
        "twitter": "https://twitter.com/TPMAN_1998",
        "title": "Doll",
        "descZh": "Doll will be the best TokenPocket wallet skin. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Doll will be the best TokenPocket wallet skin. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#081523",
        "layout": "full",
        "group": 6,
        "nfts": [
            {
                "id": 12,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/12.png"
            },
            {
                "id": 14,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/14.png"
            },
            {
                "id": 13,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/13.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x3c72cfb6d7ca106cefcc5cc22c28b34d812a8bad/eth"
    },
    {
        "twitter": "https://twitter.com/bigbitman",
        "title": "ETH",
        "descZh": "Please mint this and set as your TokenPocket Ethereum wallet skin. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Please mint this and set as your TokenPocket Ethereum wallet skin. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#5B94C1",
        "layout": "full",
        "group": 7,
        "nfts": [
            {
                "id": 16,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/16.png"
            },
            {
                "id": 15,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/15.png"
            },
            {
                "id": 17,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/17.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x91d570acd8e998f25e4aa650dd6bacf18dd60fee/eth"
    },
    {
        "twitter": "https://twitter.com/Bong29279628",
        "title": "Etherverse",
        "descZh": "Ethereum Metaverse. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Ethereum Metaverse. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#000000",
        "layout": "full",
        "group": 8,
        "nfts": [
            {
                "id": 18,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/18.png"
            },
            {
                "id": 20,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/20.png"
            },
            {
                "id": 19,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/19.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xc0cb3d5d795de49520001ea1fb40a962afcf9aa2/eth"
    },
    {
        "twitter": "https://twitter.com/kevin26261057",
        "title": "The Metaverse Life of KAKA MONSTER",
        "descZh": "KAKA MONSTER旗下GATI和GINA的朋克造型，与元宇宙情景的融合，预示着我们即将拥抱元宇宙生活的到来。. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "The fusion of the punk shapes of GATI and GINA under KAKA MONSTER with the metaverse scene indicates that we are about to embrace the arrival of the metaverse life. TokenPocket’s First Wallet Skin NFT Design Competition works. .",
        "viewAll": true,
        "bgColor": "#C4B4EA",
        "layout": "full",
        "group": 9,
        "nfts": [
            {
                "id": 21,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/21.png"
            },
            {
                "id": 23,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/23.png"
            },
            {
                "id": 22,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/22.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/?utm_source=tokenpocket#/address/0x6917e4318b94109d0174161a7994832554cbd431/bsc"
    },
    {
        "twitter": "https://twitter.com/Token97Hub",
        "title": "Life Is A Fucking Movie",
        "descZh": "Crypto Life Is A Fucking Movie. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "Crypto Life Is A Fucking Movie. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#0CA35C",
        "layout": "full",
        "group": 10,
        "nfts": [
            {
                "id": 24,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/24.png"
            },
            {
                "id": 26,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/26.png"
            },
            {
                "id": 25,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/25.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x78de673d168f3b5573376219f0baab94eaee4316/eth"
    },
    {
        "twitter": "https://twitter.com/lichao199466",
        "title": "Miss Huang",
        "descZh": "我爱黄小姐。. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "I love Miss Huang. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#FFC0C0",
        "layout": "full",
        "group": 11,
        "nfts": [
            {
                "id": 27,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/27.png"
            },
            {
                "id": 28,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/28.png"
            },
            {
                "id": 29,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/29.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0xdcad70562e7c19524de100d330a2d28b2c84cdd1/bsc"
    },
    {
        "twitter": "https://twitter.com/Melo1997_",
        "title": "The Creation of Alien. ",
        "descZh": "“创造外星人”，该作品是为了致敬“创造亚当”. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "The Creation of Alien is made for saluting The Creation of Adam. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#2D235A",
        "layout": "full",
        "group": 12,
        "nfts": [
            {
                "id": 30,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/30.png"
            },
            {
                "id": 32,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/32.png"
            },
            {
                "id": 31,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/31.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x3b490503f126f48e640310b028e50338e08ccc72/eth"
    },
    {
        "twitter": "https://twitter.com/RPXXXA",
        "title": "TP BOYZ",
        "descZh": "The Metaverse Boyz. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "The Metaverse Boyz. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#215591",
        "layout": "full",
        "group": 13,
        "nfts": [
            {
                "id": 33,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/33.jpg"
            },
            {
                "id": 35,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/35.jpg"
            },
            {
                "id": 34,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/34.jpg"
            }
        ],

        "fivedegrees": "https://fans3.5degrees.io/#/address/0xace1F0ea389F5b766b534e436a2D880a95100EEE/bsc"
    },
    {
        "twitter": "https://twitter.com/JOJOgamefi",
        "title": "TP Moon Walk",
        "descZh": "希望每一位用TP的小伙伴都可以去往月球LFG. TokenPocket首届NFT皮肤设计大赛作品。tokenpocket.pro。",
        "descEn": "I hope everyone who uses TP can go to the moon LFG. TokenPocket’s First Wallet Skin NFT Design Competition works. ",
        "viewAll": true,
        "bgColor": "#374A6C",
        "layout": "full",
        "group": 14,
        "nfts": [
            {
                "id": 38,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/38.png"
            },
            {
                "id": 36,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/36.png"
            },
            {
                "id": 37,
                "url": "https://tp-statics.tokenpocket.pro/images/nft-design/37.png"
            }
        ],
        "fivedegrees": "https://fans3.5degrees.io/#/address/0x3cdbce5d2f4f4616018b6181b15fb1d0a9098004/bsc"
    },



]



export const MULTI_ABI = [
    {
        "constant": false,
        "inputs": [
            {
                "components": [
                    {
                        "name": "target",
                        "type": "address"
                    },
                    {
                        "name": "callData",
                        "type": "bytes"
                    }
                ],
                "name": "calls",
                "type": "tuple[]"
            }
        ],
        "name": "aggregate",
        "outputs": [
            {
                "name": "blockNumber",
                "type": "uint256"
            },
            {
                "name": "returnData",
                "type": "bytes[]"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
]

export const ABI = [
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start_",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end_",
                "type": "uint256"
            },
            {
                "internalType": "string",
                "name": "uri_",
                "type": "string"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "mint",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            }
        ],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "group",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            }
        ],
        "name": "Mint",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "amounts",
                "type": "uint256[]"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeBatchTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "uri_",
                "type": "string"
            }
        ],
        "name": "setBaseURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds_",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "groups_",
                "type": "uint256[]"
            }
        ],
        "name": "setGroup",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "price_",
                "type": "uint256"
            }
        ],
        "name": "setPrice",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldPrice",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newPrice",
                "type": "uint256"
            }
        ],
        "name": "SetPrice",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldStart",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newStart",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "oldEnd",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newEnd",
                "type": "uint256"
            }
        ],
        "name": "SetStartTime",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start_",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end_",
                "type": "uint256"
            }
        ],
        "name": "setTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            },
            {
                "indexed": false,
                "internalType": "uint256[]",
                "name": "values",
                "type": "uint256[]"
            }
        ],
        "name": "TransferBatch",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "TransferSingle",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "string",
                "name": "value",
                "type": "string"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            }
        ],
        "name": "URI",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "tokens",
                "type": "address[]"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "withdrawTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "accounts",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "ids",
                "type": "uint256[]"
            }
        ],
        "name": "balanceOfBatch",
        "outputs": [
            {
                "internalType": "uint256[]",
                "name": "",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "end_time",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "groups",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "groupTotalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mint_price",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "start_time",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "uri",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
];